import styled from "styled-components";

export const CellBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 1px solid ${props => props.theme.colors.lightShade};
    padding: ${props => props.theme.spacing.spacing8};
    font-size: ${props => props.theme.fontSize.body2};
`